/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsOrderAttachment,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderCreate
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderCreate {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsOrderAttachment>}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderCreate
     */
    attachments?: Array<DigitizingserviceMelcoDigitizingModelsOrderAttachment> | null;
}

export function DigitizingserviceMelcoDigitizingModelsOrderCreateFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderCreate {
    return DigitizingserviceMelcoDigitizingModelsOrderCreateFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSON)),
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderCreateToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAttachmentToJSON)),
    };
}


